import * as React from "react";

type Props = {
  children: React.ReactNode;
};

export default class IntroWithButton extends React.PureComponent<Props> {
  static displayName = "Panel.IntroWithButton";

  render() {
    const children = React.Children.toArray(this.props.children);

    let intro;
    let button;
    if (children.length === 1) {
      intro = children;
    } else {
      button = children.pop();
      intro = children;
    }

    if (button) {
      button = <div className="ml-3 flex-none">{button}</div>;
    }

    return (
      <div className="flex px-4 py-4">
        <div className="flex min-w-0 flex-auto items-center">{intro}</div>
        {button}
      </div>
    );
  }
}
